import {FormFieldSchema, FormFieldType,} from "@app/components/forms/types/schema"

// validation 등록 필요
export const ConversionCodeSchema: FormFieldSchema[] = [
  {
    type: FormFieldType.Group,
    id: "conversionCodeGroup",
    label: "전환 코드",
    noneStyle: true,
    schemas: [
        {
          type: FormFieldType.Text,
          id: "conversionCode",
          defaultValue: "",
          label: "전환 코드",
          description:
              "카페24 통계 페이지에서 식별할 수 있는 추적 코드를[mo] 문자나 숫자의 형태로 넣어주세요. 예) shortform",
          placeholder: "전환 코드를 입력해주세요.",
        }
    ]
  }
];
